import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionNo, PlaceholderTag } from "@/components/primitives";
import { images, placeholders } from "@/config/site";
import { useScroll as useSmooth } from "@/lib/scroll";

export default function Programme() {
  const ref = useRef(null);
  const { scrollTo } = useSmooth();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="programme"
      ref={ref}
      className="on-dark relative overflow-hidden border-y border-hairline"
      data-testid="programme"
    >
      <motion.img
        src={images.brandFilm}
        alt="A warm, low-lit luxury interior with depth and atmosphere"
        loading="lazy"
        style={{ y: bgY }}
        className="atmos absolute inset-0 h-[124%] w-full object-cover"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, rgba(18,16,14,0.96) 0%, rgba(18,16,14,0.86) 45%, rgba(18,16,14,0.62) 100%)",
        }}
        aria-hidden="true"
      />
      <div className="grain" aria-hidden="true" />

      <div className="relative mx-auto max-w-[1280px] px-6 py-36 sm:px-10 md:py-52">
        <div className="max-w-[62ch]">
          <Reveal>
            <SectionNo n="08" label="The programme" />
          </Reveal>
          <Reveal delay={0.08}>
            <h2
              className="display mt-8 text-primaryText"
              style={{
                fontSize: "clamp(2.5rem, 6.5vw, 5.5rem)",
                lineHeight: 0.99,
                letterSpacing: "-0.02em",
                fontWeight: 300,
              }}
            >
              Your library, working all year.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-10 text-base leading-relaxed text-mutedText sm:text-lg">
              An agreed number of films each quarter, drawn from the photography
              you already own and scheduled around your calendar: seasons,
              reopenings, campaigns. Your archive stops being a folder and
              becomes a channel.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 font-mono text-xs tracking-wide text-mutedText">
              {placeholders.programmeCadence}
              <PlaceholderTag /> · paused or rescheduled around your occupancy
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <button
              onClick={() => scrollTo("#enquiry")}
              className="btn-sweep mt-12 rounded-full bg-brass px-8 py-4 text-sm font-medium tracking-wide text-ink transition-colors duration-300 hover:bg-[#c9aa6c]"
              data-testid="programme-cta"
            >
              Ask about the programme
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
